import { Button, Icon, Tooltip, TooltipPopup, TooltipTrigger } from "@salestrak/ui";

import { useCopyFeedback } from "#app/lib/utils/copy-actions";

/**
 * The glyph-only copy control: a ghost icon button that flips to a check for
 * `COPY_FEEDBACK_MS` after a copy lands. `what` names the value for the
 * label, tooltip and toast ("Copy URL" → "URL copied").
 */
export function CopyIconButton({
  text,
  what,
  size = "icon",
}: {
  text: string;
  what: string;
  size?: "icon" | "icon-xs";
}) {
  const { copied, copy } = useCopyFeedback();
  const label = `Copy ${what}`;
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            aria-label={label}
            onClick={() => void copy(text, what)}
            size={size}
            variant="ghost"
          />
        }
      >
        <Icon name={copied ? "check" : "copy"} size="md" />
      </TooltipTrigger>
      <TooltipPopup>{copied ? "Copied" : label}</TooltipPopup>
    </Tooltip>
  );
}
